import { render, staticRenderFns } from "./addOfficaial2.vue?vue&type=template&id=9c63bffc&scoped=true"
import script from "./addOfficaial2.vue?vue&type=script&lang=js"
export * from "./addOfficaial2.vue?vue&type=script&lang=js"
import style0 from "./addOfficaial2.vue?vue&type=style&index=0&id=9c63bffc&prod&lang=less&scoped=true"
import style1 from "./addOfficaial2.vue?vue&type=style&index=1&id=9c63bffc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c63bffc",
  null
  
)

export default component.exports